import React, { useRef, useEffect, useState } from "react";
import { photoUrl } from "../../config";

export default function DesignPreviewScroller({
  imgClassName = "w-[85px] h-[64px]",
  gap = "gap-1.5",
  room,
  roomPhotoUrl,
  accentColor = "#14b8a6",
  textColor,
}) {
  const [numbersList, setNumbersList] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    // фотки номеров
    const list = [];
    for (const n of room.numbers) {
      if (n?.separate) {
        list.push({
          ...n,
          src: n?.photos?.[0]
            ? `${photoUrl}/${roomPhotoUrl}/numbers/${n.photos[0]}.jpg`
            : `/empty.jpg`,
        });
      }
    }
    setNumbersList(list);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const handleWheel = (e) => {
      e.preventDefault();
      e.stopPropagation();
      el.scrollLeft += e.deltaY;
    };
    el.addEventListener("wheel", handleWheel, { passive: false });
    return () => el.removeEventListener("wheel", handleWheel);
  }, []);

  return (
    <div
      ref={scrollRef}
      className={`flex ${gap} overflow-x-auto`}
      style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
    >
      {numbersList.map((number, i) => (
        <img
          key={i}
          src={number.src}
          alt={`Дизайн ${i + 1}`}
          className={`flex-shrink-0 ${imgClassName} object-cover rounded-lg border-2 border-white shadow-sm hover:border-teal-400 transition-colors`}
          style={{ borderColor: "white" }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.borderColor = accentColor)
          }
          onMouseLeave={(e) => (e.currentTarget.style.borderColor = "white")}
        />
      ))}
    </div>
  );
}
